module.exports = __webpack_public_path__ + "media/images/athletes/2828-c6bff35603d29a56371c714db404ee30.png";